module.exports = __webpack_public_path__ + "img/swzsk.af74168c.svg";